/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CombineWithAnotherCompanyResponse
 */
export interface CombineWithAnotherCompanyResponse {
  /**
   *
   * @type {string}
   * @memberof CombineWithAnotherCompanyResponse
   */
  errorMessage?: string | null;
}

/**
 * Check if a given object implements the CombineWithAnotherCompanyResponse interface.
 */
export function instanceOfCombineWithAnotherCompanyResponse(
  value: object,
): value is CombineWithAnotherCompanyResponse {
  return true;
}

export function CombineWithAnotherCompanyResponseFromJSON(
  json: any,
): CombineWithAnotherCompanyResponse {
  return CombineWithAnotherCompanyResponseFromJSONTyped(json, false);
}

export function CombineWithAnotherCompanyResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CombineWithAnotherCompanyResponse {
  if (json == null) {
    return json;
  }
  return {
    errorMessage:
      json["errorMessage"] == null ? undefined : json["errorMessage"],
  };
}

export function CombineWithAnotherCompanyResponseToJSON(
  json: any,
): CombineWithAnotherCompanyResponse {
  return CombineWithAnotherCompanyResponseToJSONTyped(json, false);
}

export function CombineWithAnotherCompanyResponseToJSONTyped(
  value?: CombineWithAnotherCompanyResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    errorMessage: value["errorMessage"],
  };
}
